export * from "./Table.style";
